import GoogleMapStaticCustom from './google-map-static-custom';
export default GoogleMapStaticCustom;